import React, { useState, useMemo } from 'react';
import { toast } from 'react-toastify';
import { postStartEmailConfirmationAPI } from 'src/serverApi/account';
import styles from './styles.module.scss';
import InputField from 'src/components/InputField';
import Text from 'src/components/Text';

type Props = {
  value: string;
  onChange: any;
  error: string;
  accountProfile: any;
};

const EmailInput: React.FC<Props> = ({ value, onChange, error, accountProfile }) => {
  const { emailConfirmationStatus } = accountProfile || {};

  const [isConfirmationStarted, setIsConfirmationStarted] = useState(
    emailConfirmationStatus === 'CONFIRMATION_SENT'
  );

  const confirmEmail = async () => {
    try {
      await postStartEmailConfirmationAPI();
      toast.success('На почту отправлена ссылка для подтверждения адреса');
      setIsConfirmationStarted(true);
    } catch (error) {
      toast.error('Произошла ошибка. Попробуйте позже.');
    }
  };

  const handleClick = (e: any) => {
    e.preventDefault();
    confirmEmail();
  };

  const renderedInputDescription = useMemo(() => {
    if (emailConfirmationStatus === 'CONFIRMED') {
      return (
        <Text type="span" small className={styles['input-description']}>
          Адрес почты подтвержден
        </Text>
      );
    } else if (isConfirmationStarted) {
      return (
        <Text type="span" small className={styles['input-description']}>
          Направлена ссылка для подтверждения адреса почты.{' '}
          <a href="#" onClick={handleClick}>
            Отправить повторно?
          </a>
        </Text>
      );
    }
    return (
      <Text type="span" small className={styles['input-description']}>
        Адрес почты не подтвержден{' '}
        <a href="#" onClick={handleClick}>
          Подтвердить
        </a>
      </Text>
    );
  }, []);

  return (
    <div className={styles['root']}>
      <InputField labelRequired label="E-mail" value={value} onChange={onChange} error={error} />
      {renderedInputDescription}
    </div>
  );
};

export default EmailInput;
